import React, {useState, useEffect}  from 'react';
import {Container, Button, Alert, Row, Col} from 'react-bootstrap';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../util/Api';
import PasswordForm from './PasswordForm'
import ProfileInviteList from './ProfileInviteList';
import UserAccountList from './UserAccountList';
//import PurchaseButton from './PurchaseButton'
//import {useSelector} from 'react-redux';
//import {getUserAccounts} from '../../app/slices/UserSlice';

//const showAnalytics = process.env.REACT_APP_ENABLE_ANALYTICS || 0;

const UserSettings = () => {

  const [errors, setErrors] = useState([]);
  const [user, setUser] = useState(null);
  var [refresh, setRefresh] = useState(null);

  //const [accounts, setAccounts] = useState(null);
  const [passwdFormVisible, setPasswdFormVisible] = useState(false)

  let navigate = useNavigate();

  const [searchParams] = useSearchParams();
  //let refresh = searchParams.get('refresh') ? searchParams.get('refresh') : null;
  let {accountKey} = useParams();

  //const currUserAccounts = useSelector(getUserAccounts);
  //const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  //const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

  let xsWidth = 3;
  let smWidth = 3;
  let mdWidth = 2;
  //let lgWidth = 2;

  /*
  const updateProfile = (val) => { 
    //console.log('in profile update')
    navigate(`/account/${accountKey}/profile?refresh=${val}`);
    //return;
  }
*/

  useEffect(() => {
    document.title = `reconify profile`;

    let options = {
      /*accountKey: accountKey,
      includeUsage: 1*/
    }
    let isAuthError = false;

    axios.post(apiUrl + '/users/detail',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(res.data.user !== null){
          setUser(res.data.user);
          //setAccounts(res.data.user.accounts);
        }
        else {
          //need to show a message that model is missing?
        }
      } else {
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-valid-user':
            case 'no-permissions':
              isAuthError = true;
              redirectToLogin = true;
              break;
            case 'inactive-user':
              errorMsgs.push('The profile is inactive.');
              break;
            default:
              errorMsgs.push('There was an error retrieving the account.');
          }
        });
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        //don't call setErrors if not logged in as it throws an unmounted error
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {

    });

  },[navigate, refresh]);

  return (
    <Container fluid>
        <div>
          <h3>Profile</h3>
          {
            errors.length > 0 ? (
              <Alert variant='danger'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }

          {
            user !== null ? (
              <>
              <Container className='mb-3'>
                <Row className='my-2'>
                  <Col xs={xsWidth} sm={smWidth} md={mdWidth} className='detailLabel'>Email:</Col>
                  <Col className='detailData'>{user.email}</Col>
                </Row>
                <Row className='my-2'>
                  <Col xs={xsWidth} sm={smWidth} md={mdWidth}  className='detailLabel'>Password</Col>
                  <Col className='detailData'>
                    <Button  onClick={() => setPasswdFormVisible(!passwdFormVisible)} size='sm'>Change Password</Button>
                    {passwdFormVisible ? (
                      <PasswordForm/>
                    ) : (null)}
                  </Col>
                </Row>
              </Container>
              <ProfileInviteList updateProfile={setRefresh}/>
              <UserAccountList refresh={refresh}/>
              </>
            ) : (null)
          }



        </div>

    </Container>
  )
}

export default UserSettings;
